import NP from 'number-precision';
import { PositionSetting } from "domain/positionSetting";
import Commodity from 'domain/commodity';

export default function getLotsToHedge(positionSetting: PositionSetting, commodity: Commodity, quantity: number, useMini: boolean): number {
    if (useMini && positionSetting.miniContractMinimum == null) useMini = false;

    const contractSize = useMini ? commodity.miniContractSize : commodity.contractSize;

    const minContractPercent = NP.divide(useMini ? positionSetting.miniContractMinimum : positionSetting.fullContractMinimum, 100);
    const minContract = NP.times(minContractPercent, contractSize);

    const fullContracts = Math.floor(NP.divide(quantity, contractSize));
    const remainder = NP.minus(quantity, NP.times(fullContracts, contractSize));

    return remainder >= minContract
        ? fullContracts + 1
        : fullContracts;
}